import Main from "./variants/Main";
import Pending from "./variants/Pending";
import History from "./variants/History";

export default {
  Main,
  Pending,
  History,
};
